import DownloadIcon from '@mui/icons-material/Download';
import { Link } from "@mui/material";
import Grid from '@mui/material/Grid';
import { FC } from 'react';

type EventGalleryPhotoProps = {
    eventId: string;
    photoId: string;
    downloadImage: (evenId: string, imageId: string) => Promise<void>;
}

const EventGalleryPhotoToolsFree: FC<EventGalleryPhotoProps> = ({ eventId, photoId, downloadImage }) => {
    return (
        <Grid
            size={12}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                p: 1,
            }}
        >
            <Link
                onClick={() => downloadImage(eventId, photoId)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 1,
                    borderRadius: 1,
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: 'primary.main',
                    backgroundColor: 'background.paper',
                    color: 'primary.main',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        backgroundColor: 'action.hover',
                        borderColor: 'primary.dark',
                        transform: 'scale(1.05)',
                    },
                }}
            >
                <DownloadIcon
                    sx={{
                        color: 'primary.main',
                        fontSize: '1.5rem',
                    }}
                />
            </Link>
        </Grid>
    )
}

export { EventGalleryPhotoToolsFree };
